export default "__VITE_PUBLIC_ASSET__0896eadf__"